import React from "react";
import { Badge, Button, Form, InputGroup, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";

//TODO: Duplicate Code Create / Update
class UpdateClassDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isClassName,
      },
      members: {
        defaultValue: [],
        rule: ValidationHelper.isMemberArray,
      },
    };
    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      newStudentEmail: "",
      newStudentName: "",
      newStudentAuthenticatorUserId: "",
      newStudentValid: false,
      addedStudents: new Set(),
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
    this.handleAddStudent = this.handleAddStudent.bind(this);
    this.handleRemoveStudent = this.handleRemoveStudent.bind(this);
    this.handleCheckEmail = this.handleCheckEmail.bind(this);
  }

  async handleCheckEmail(email) {
    if (ValidationHelper.isEmail(email)) {
      try {
        const foundStudents = await CamplaCoreService.lookupUser(email);
        if (foundStudents.length > 0) {
          this.setState({
            newStudentValid: true,
            newStudentEmail: foundStudents[0].email,
            newStudentAuthenticatorUserId: foundStudents[0].authenticatorUserId,
          });
          return;
        }
      } catch (err) {
        console.log(err);
      }
    }
    this.setState({ newStudentValid: false });
  }

  handleAddStudent() {
    if (
      this.state.newStudentValid &&
      this.state.newStudentName.length > 2 &&
      this.state.newStudentAuthenticatorUserId.length > 0 &&
      !this.state.addedStudents.has(this.state.newStudentEmail)
    ) {
      const updatedMembers = [
        {
          authenticatorUserId: this.state.newStudentAuthenticatorUserId,
          name: this.state.newStudentName,
          email: this.state.newStudentEmail,
        },
        ...this.state.validation.members.value,
      ];
      const addedStudents = new Set(updatedMembers.map((s) => s.email));
      this.setState({
        addedStudents: addedStudents,
        validation: ValidationHelper.update(
          {
            target: {
              name: "members",
              value: updatedMembers,
            },
          },
          this.state.validation
        ),
      });
    }
  }

  handleRemoveStudent(student) {
    const updatedMembers = this.state.validation.members.value.filter(
      (mb) => mb.authenticatorUserId !== student.authenticatorUserId
    );
    const addedStudents = new Set(updatedMembers.map((s) => s.email));
    this.setState({
      addedStudents: addedStudents,
      validation: ValidationHelper.update(
        {
          target: {
            name: "members",
            value: updatedMembers,
          },
        },
        this.state.validation
      ),
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        newStudentEmail: "",
        newStudentName: "",
        newStudentAuthenticatorUserId: "",
        newStudentValid: false,
        addedStudents: new Set(this.props.class.members.map((s) => s.email)),
        validation: ValidationHelper.getValidation(
          {
            name: {
              defaultValue: this.props.class.name,
              rule: ValidationHelper.isClassName,
            },
            members: {
              defaultValue: this.props.class.members,
              rule: ValidationHelper.isMemberArray,
            },
          },
          true
        ),
      });
    } else if (!this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        validation: ValidationHelper.getValidation(
          this.validationDefinition,
          true
        ),
      });
    }
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Classes.ClassModal.UpdateModalTitle")}
        dialogApiError={this.props.dialogApiError}
        rightButtonText={t("Classes.ClassModal.Form.Submit")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonText={t("DialogCancel")}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <Form>
            <Form.Group controlId="formClassName">
              <Form.Label>{t("Classes.ClassModal.Form.ClassName")}</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder={t("Classes.ClassModal.Form.ClassNamePlaceholder")}
                value={this.state.validation.name.value}
                isInvalid={!this.state.validation.name.isValid}
                onChange={this.handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {t("Classes.ClassModal.ValidationError.Name")}
              </Form.Control.Feedback>
            </Form.Group>
            <p>
              {t("Classes.ClassModal.Form.Students")}
              <Badge variant="secondary" className="ml-1">
                {this.state.validation.members.value
                  ? this.state.validation.members.value.length
                  : 0}
              </Badge>
            </p>
            <InputGroup>
              <Form.Control
                isInvalid={!this.state.newStudentValid}
                onChange={(event) => {
                  this.setState({
                    newStudentEmail: event.target.value,
                  });
                  this.handleCheckEmail(event.target.value);
                }}
                placeholder={t(
                  "Classes.ClassModal.Form.StudentsEmailPlaceholder"
                )}
              />
              <Button
                variant="btn btn-green"
                disabled={
                  !(
                    this.state.newStudentValid &&
                    this.state.newStudentName.length > 2
                  )
                }
                onClick={this.handleAddStudent}
                style={{
                  borderBottomLeftRadius: "0px",
                  borderTopLeftRadius: "0px",
                }}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </InputGroup>
            <Form.Control
              className="mt-2"
              isInvalid={this.state.newStudentName.length < 3}
              onChange={(event) => {
                this.setState({
                  newStudentName: event.target.value,
                });
              }}
              placeholder={t("Classes.ClassModal.Form.StudentsNamePlaceholder")}
            />
            <Table size="sm" className="students-table mt-2">
              <thead>
                <tr>
                  <th>{this.props.t("Classes.ClassModal.Form.ColumnName")}</th>
                  <th>{this.props.t("Classes.ClassModal.Form.ColumnEmail")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.validation.members.value.map((m, idx) => (
                  <tr key={idx}>
                    <td>{m.name}</td>
                    <td>{m.email}</td>
                    <td>
                      <Button
                        className="btn btn-red btn-sm floatRight"
                        onClick={() => this.handleRemoveStudent(m)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Form>
        }
      />
    );
  }
}

export default withTranslation()(UpdateClassDialog);
